module.exports = __webpack_public_path__ + "img/cu_logo_4c_centre.7b4e9472.png";